<template>
	<div class="main-content-padding" style="height: 100%">
		<Panel :contentPaddingTop="0" style="min-height: 100%">
			<div class="pos-rela">
				<el-tabs v-model="activeName">
					<el-tab-pane :label="item.label" :name="item.name" v-for="(item, index) in tabList" :key="index"></el-tab-pane>
				</el-tabs>
				<div class="pos-abso guide">
					<a class="cursor-pointer" href="https://yangxuan.feishu.cn/docx/QBi1dYlR8obf1QxGdUWcbmyVnrh?from=from_copylink" target="_blank">
						<div class="tag flex-row-align-center">
							<i class="i-light-bulb mb-2"></i>
							<span class="ml-8 yx-color-text-primary">使用说明</span>
						</div>
					</a>
				</div>
			</div>
			<div class="mt-6">
				<component :is="activeName"></component>
			</div>
		</Panel>
	</div>
</template>
<script>
import { tabList } from './const';
import Account from './components/account.vue';
import FilterRule from './components/filterRule.vue';
import ClueFilter from './components/filter.vue';
import ConcactObtain from './components/concactObtain.vue';
import Distribute from './components/distribute.vue';

export default {
	components: {
		Account,
		FilterRule,
		ClueFilter,
		ConcactObtain,
		Distribute,
	},
	data() {
		const list = tabList.map(item => ({ ...item, isShow: this.$auth.hasPermi(item.auth) })).filter(item => item.isShow);
		// const list = tabList.map(item => ({ ...item, isShow: true }));
		return {
			tabList: Object.freeze(list),
			activeName: list[0].name,
		};
	},
	mounted() {},
};
</script>
<style lang="less" scoped>
.guide {
	top: 12px;
	right: 0;

	.tag {
		background: #fff6f2;
		height: 30px;
		border-radius: 30px;
		font-size: 13px;
		line-height: 30px;
		padding: 0px 12px;
	}
}
</style>
